// Auth API helpers — thin wrappers over the shared fetch client.

import { api, ApiError } from './client.js';

export async function login({ email, password, returnTo }) {
  const body = { email, password };
  if (returnTo != null) body.return_to = returnTo;
  // skip401 prevents the centralised 401 handler from redirecting on a
  // bad-credentials response — LoginView handles that itself.
  return api.post('/auth/login', body, { skip401: true });
}

export async function logout(csrfToken) {
  return api.post('/auth/logout', null, { csrf: csrfToken });
}

export async function fetchCsrfBootstrap() {
  return api.get('/csrf');
}

// -------------------------------------------------------------------
// Password reset (Epic 5) — endpoints públicos. skip401 porque ninguno
// tiene sesión asociada; el 401 handler global no debe redirigirlos.
// -------------------------------------------------------------------
export async function requestPasswordReset(email) {
  return api.post('/auth/password-reset/request', { email }, { skip401: true });
}

export async function checkResetTokenValidity(token) {
  // 200 = valid; 410 = invalid → ApiError(status=410, code='token_invalid').
  const qs = new URLSearchParams({ token }).toString();
  return api.get(`/auth/password-reset/token-validity?${qs}`, { skip401: true });
}

export async function confirmPasswordReset({ token, password }) {
  return api.post('/auth/password-reset/confirm', { token, password }, { skip401: true });
}

// Story 5.4 — { smtpEnabled: bool }; usado por el frontend para gatear
// la "Forgot password?" link en LoginView y por el router para
// redirigir `/reset-password*` cuando SMTP no está configurado.
export async function fetchAuthConfig() {
  return api.get('/auth/config', { skip401: true });
}

export { ApiError };
